import { render, staticRenderFns } from "./PageSellerTable.vue?vue&type=template&id=3b01adbc&scoped=true"
import script from "./PageSellerTable.vue?vue&type=script&lang=js"
export * from "./PageSellerTable.vue?vue&type=script&lang=js"
import style0 from "./PageSellerTable.vue?vue&type=style&index=0&id=3b01adbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b01adbc",
  null
  
)

export default component.exports